var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "movie-banner-config",
      attrs: { disabled: _vm.disabled, model: _vm.value.config },
    },
    [
      _c(
        "div",
        { staticStyle: { display: "flex", "margin-bottom": "10px" } },
        [
          _c(
            "el-input",
            {
              attrs: { disabled: "", placeholder: "请输入" },
              model: {
                value: _vm.value.config.width,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "width", $$v)
                },
                expression: "value.config.width",
              },
            },
            [_c("template", { slot: "append" }, [_vm._v("宽")])],
            2
          ),
        ],
        1
      ),
      _c("div", { staticClass: "tips", staticStyle: { color: "#999999" } }, [
        _vm._v(
          " 支持PNG、JPG等格式，展示宽度默认为750，高度根据原图等比例展示 "
        ),
      ]),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
      _c(
        "draggable",
        {
          attrs: { animation: "500", "force-fallback": true },
          model: {
            value: _vm.value.config.value,
            callback: function ($$v) {
              _vm.$set(_vm.value.config, "value", $$v)
            },
            expression: "value.config.value",
          },
        },
        _vm._l(_vm.value.config.value, function (item, index) {
          return _c(
            "div",
            { key: index, staticClass: "upload-item" },
            [
              _c("div", { staticClass: "item-title" }, [
                _vm._v("轮播图" + _vm._s(index + 1)),
              ]),
              _c(
                "div",
                { staticClass: "upload" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "value." + index + ".imageurl",
                        rules: [{ required: true, message: "轮播图不可为空" }],
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "upload-item-wrap" },
                        [
                          _c("upload-file", {
                            ref: "uploadBanner",
                            refInFor: true,
                            attrs: {
                              "link-url": _vm.linkUrl,
                              tempurl: item.imageurl,
                              canDel: _vm.value.config.value.length > 1,
                              deletePadding: true,
                              uploadInfo: _vm.uploadInfo,
                            },
                            on: {
                              onDelete: function ($event) {
                                return _vm.handleDelUpload(index)
                              },
                              emitUploadFile: function (res) {
                                return _vm.emitUploadFile(res, item)
                              },
                            },
                          }),
                          _c(
                            "div",
                            { staticClass: "btns" },
                            [
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.onUpload(index)
                                    },
                                  },
                                },
                                [_vm._v(" 上传图片 ")]
                              ),
                              _vm.pictureList.length > 0
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectPicture(index)
                                        },
                                      },
                                    },
                                    [_vm._v(" 选择图片 ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "value." + index + ".link_type" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: {
                        change: function (_) {
                          return _vm.radioChange(item)
                        },
                      },
                      model: {
                        value: item.link_type,
                        callback: function ($$v) {
                          _vm.$set(item, "link_type", $$v)
                        },
                        expression: "item.link_type",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("选电影"),
                      ]),
                      _c("el-radio", { attrs: { label: "2" } }, [
                        _vm._v("选影院"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              item.link_type === "2"
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "value." + index + ".city_id" } },
                    [
                      _c("el-cascader", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          options: _vm.cityList,
                          props: {
                            checkStrictly: true,
                          },
                          filterable: "",
                          placeholder: "请选择城市",
                        },
                        on: {
                          change: function (val) {
                            return _vm.changeCity(item, val, item.uid, true)
                          },
                        },
                        model: {
                          value: item.city_id,
                          callback: function ($$v) {
                            _vm.$set(item, "city_id", $$v)
                          },
                          expression: "item.city_id",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { prop: "value." + index + ".link_value" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder:
                          "请选择" + (item.link_type === "1" ? "电影" : "影院"),
                        disabled:
                          item.link_type === "2" && _vm.isEmpty(item.city_id),
                      },
                      model: {
                        value: item.link_value,
                        callback: function ($$v) {
                          _vm.$set(item, "link_value", $$v)
                        },
                        expression: "item.link_value",
                      },
                    },
                    _vm._l(
                      item.link_type === "1"
                        ? _vm.movieList
                        : _vm.cinemaObj[item.uid],
                      function (o) {
                        return _c("el-option", {
                          key: o.id,
                          attrs: {
                            label:
                              o[
                                item.link_type === "1"
                                  ? "movie_name"
                                  : "cinema_name"
                              ],
                            value: o.id,
                          },
                        })
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        0
      ),
      _c(
        "el-button",
        {
          staticClass: "el-icon-plus add-upload",
          attrs: { type: "primary" },
          on: { click: _vm.addUpload },
        },
        [_vm._v(" 新增轮播图")]
      ),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureList: _vm.pictureList,
              depot: _vm.depot,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }